import { categoryList } from '@/api/client/nav'

export default {
  namespaced: true,
  state: () => ({
    categoryList: []
  }),
  mutations: {
    SET_CATEGORY_LIST(state, list) {
      state.categoryList = list
    }
  },
  actions: {
    async fetchCategoryList({ commit }, langCode) {
      try {
        const res = await categoryList(langCode)
        if (res.code === 200) {
          commit('SET_CATEGORY_LIST', res.data)
        }
      } catch (error) {
        console.error('获取导航栏数据失败:', error)
      }
    }
  }
}